import ThemedButtonBar from 'components/atoms/ThemedButtonBar'
import React, { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import { View } from 'react-native'
import { ThemedValues } from 'styles/themed'
import ThemedSelect from 'components/atoms/ThemedSelect'
import TopNavigationTabBar from 'components/atoms/TopNavigationTabBar'
import isEqual from 'react-fast-compare'
import { tabBarStyles } from 'styles/components/atoms/TabBar'
import { layoutStyles } from 'styles/layout'
import HelperPlatform from 'utils/helper-platform'
import { useNavigation, useRoute } from '@react-navigation/native'

const TabBar = ({ items = [], noMargin, props = {}, onPress = null, topTabbar }) => {
	
	const navigation = useNavigation();
	const route = useRoute()
	
	const pageWidthRef = useRef( 0 );
	const buttonBarWidthRef = useRef( 0 );
	
	const [ selected, setSelected ] = useState( route?.params?.tab ?? null )
	const [ showButtonBar, setShowButtonBar ] = useState( true )
	
	const onTabPress = ( data ) => {
		setSelected( data );
		
		// Also update the param
		navigation.setParams({ tab: data })
		
		if( _.isFunction( onPress ) ){
			onPress( data );
		}
	}
	
	let selectedItem = _.find( items, { key: selected } )
	if( _.isUndefined( selectedItem ) ) {
		selectedItem = _.first( items )
	}
	
	let selectedContent = null;
	if( !_.isUndefined( selectedItem ) ) {
		selectedContent = selectedItem.scene( props )
	}
	
	const barStyle = {
		...layoutStyles.flexUnset,
		marginVertical: noMargin ? 0 : ThemedValues.marginVertical
	}
	
	const validateButtonBarWidth = () => {
		setShowButtonBar( pageWidthRef.current === 0 || pageWidthRef.current > buttonBarWidthRef.current )
	}
	
	const handlePageWidth = ( e ) => {
		const width = (e.nativeEvent.layout.width);
		
		if( pageWidthRef.current !== width ) {
			pageWidthRef.current = width;
			
			validateButtonBarWidth();
		}
	}
	
	const handleButtonBarWidth = ( e ) => {
		const width = (e.nativeEvent.layout.width);

		if( buttonBarWidthRef.current !== width ) {
			buttonBarWidthRef.current = width;
			
			validateButtonBarWidth();
		}
	}
	
	let tabBar = null;
	if( _.size( items ) > 1 ) {
		if( !_.isFunction( topTabbar ) ) {
			if( showButtonBar ) {
				tabBar = (
					<ThemedButtonBar
						onLayout={ handleButtonBarWidth }
						selected={ selected ?? selectedItem?.key }
						onPress={ onTabPress }
						buttons={ items }
					/>
				)
			} else {
				tabBar = (
					<ThemedSelect
						style={[ tabBarStyles.select ]}
						selected={ selected ?? selectedItem?.key }
						select={ onTabPress }
						options={ _.map( items, item => {
							return (
								{
									value: item.key,
									label: item.text
								}
							);
						})}
					/>
				)
			}
			
			tabBar = (
				<View
					style={ barStyle }>
					
					{ tabBar }
				</View>
			)
		}
	}
	
	useEffect( () => {
		if( _.isFunction( topTabbar ) ) {
			topTabbar( _.size( items ) === 1 ? null :
				<TopNavigationTabBar
					items={ items }
					noMargin
					onPress={ onTabPress }
				/>
			)
		}
	}, [ items.length ] )
	
	return (
		<View
			style={ layoutStyles.flexOne }
			onLayout={ handlePageWidth }>
			
			{ tabBar }
			
			<View
				style={ layoutStyles.flexOne }>
				
				{ selectedContent }
			</View>
		</View>
	)
}

export default React.memo( TabBar, isEqual );
